<p-toast position="top-right"></p-toast>

<section class="user-detail-page">
  <div *ngIf="isLoading" class="detail-feedback">Carregando...</div>
  <div *ngIf="errorMessage" class="detail-feedback detail-feedback--error">
    {{ errorMessage }}
  </div>

  <div *ngIf="user && !isLoading">
    <app-admin-page-header [title]="'Detalhes de ' + user.username"
      subtitle="Gerencie status da conta, dados críticos e histórico transacional.">
      <div header-actions class="detail-header-actions">
        <button *ngIf="!user.is_influencer" (click)="toggleInfluencerStatus()" class="admin-btn admin-btn--danger">
          Tornar influenciador
        </button>
        <button *ngIf="user.is_influencer" (click)="toggleInfluencerStatus()" class="admin-btn admin-btn--danger">
          Excluir como influenciador
        </button>
        <button (click)="goBack()" class="admin-btn admin-btn--secondary">
          Voltar para a lista
        </button>
      </div>
    </app-admin-page-header>

    <div class="detail-sections">
      <section class="detail-section admin-surface">
        <div class="detail-section__header">
          <h3>Perfil e dados bancarios</h3>
          <span class="influencer-status" *ngIf="user.is_influencer">
            Influenciador
          </span>
          <app-admin-status-badge [limited]="user.is_limited"></app-admin-status-badge>
        </div>

        <div class="detail-profile-grid">
          <article class="detail-card detail-card--nested">
            <h4>Dados do usuario</h4>
            <div class="detail-kv">
              <span>Nome</span>
              <strong>{{ user.first_name || "N/A" }}
                {{ user.last_name || "" }}</strong>
            </div>
            <div class="detail-kv">
              <span>Documento</span>
              <strong>{{ user.document_number || "-" }}</strong>
            </div>
            <div class="detail-kv">
              <span>Nascimento</span>
              <strong>{{ user.birthdate | date: "dd/MM/yyyy" }}</strong>
            </div>
            <div class="detail-kv">
              <span>Criado em</span>
              <strong>{{ user.created_at | date: "dd/MM/yyyy HH:mm" }}</strong>
            </div>

            <div class="detail-email-edit">
              <label for="emailEdit">E-mail</label>
              <div class="detail-email-edit__row">
                <input id="emailEdit" type="email" class="admin-input" [(ngModel)]="editableEmail" #emailInput="ngModel"
                  required email />
                <button (click)="saveEmail()" class="admin-btn admin-btn--primary" [disabled]="
                    !emailInput.valid || editableEmail === originalEmail
                  ">
                  Salvar
                </button>
              </div>
            </div>

            <div class="detail-card__actions">
              <button (click)="forcePasswordReset()" class="admin-btn admin-btn--secondary">
                Forçar recuperacao de senha
              </button>
              <button (click)="openBalanceModal()" class="admin-btn admin-btn--primary">
                Ver saldo
              </button>
            </div>
          </article>

          <article class="detail-card detail-card--nested">
            <h4>Dados bancarios (PIX)</h4>
            <ng-container *ngIf="user.pix_data; else noPixData">
              <div class="detail-kv">
                <span>Nome completo</span>
                <strong>{{ user.pix_data.full_name }}</strong>
              </div>
              <div class="detail-kv">
                <span>Banco</span>
                <strong>{{ user.pix_data.bank_name }} ({{
                  user.pix_data.bank_code
                  }})</strong>
              </div>
              <div class="detail-kv">
                <span>Chave</span>
                <strong>{{ user.pix_data.pix_key }} ({{
                  user.pix_data.pix_key_type
                  }})</strong>
              </div>
            </ng-container>
            <ng-template #noPixData>
              <p class="detail-empty">Nenhum dado bancario cadastrado.</p>
            </ng-template>
          </article>
        </div>
      </section>

      <section class="detail-section admin-surface">
        <div class="detail-section__header">
          <h3>Gamertags</h3>
        </div>

        <div class="detail-profile-grid">
          <article class="detail-card detail-card--nested">
            <div class="detail-card__header">
              <h4>League of Legends (RIOT)</h4>
              <button *ngIf="riotActiveGamerName" (click)="unlinkGamerName('RIOT_GAMES')"
                class="admin-btn admin-btn--danger">
                Desvincular
              </button>
            </div>

            <ng-container *ngIf="riotActiveGamerName as riotTag; else noRiotTag">
              <div class="detail-kv">
                <span>Nome</span>
                <strong>
                  <button type="button" class="riot-link" (click)="openRiotTagOnOpgg(riotTag.gamer_name)"
                    title="Abrir no OP.GG">
                    {{ riotTag.gamer_name }}
                  </button>
                </strong>
              </div>
              <div class="detail-kv">
                <span>Vinculada em</span>
                <strong>{{
                  riotTag.created_at | date: "dd/MM/yyyy HH:mm"
                  }}</strong>
              </div>
              <div class="detail-kv">
                <span>Nivel</span>
                <strong>{{ riotTag.level ?? "-" }}</strong>
              </div>
              <div class="detail-kv">
                <span>Partidas</span>
                <strong>
                  {{ riotTag.total_games ?? 0 }} ({{ riotTag.wins ?? 0 }}V /
                  {{ riotTag.losses ?? 0 }}D)
                </strong>
              </div>
              <div class="detail-kv">
                <span>Winrate</span>
                <strong>{{ riotTag.winrate ?? 0 | number: "1.2-2" }}%</strong>
              </div>
              <p class="detail-empty" *ngIf="riotTag.riot_data_error">
                {{ riotTag.riot_data_error }}
              </p>
            </ng-container>
            <ng-template #noRiotTag>
              <p class="detail-empty">
                Nenhuma gamertag ativa de League of Legends.
              </p>
            </ng-template>
          </article>

          <article class="detail-card detail-card--nested">
            <div class="detail-card__header">
              <h4>Counter Strike (STEAM)</h4>
              <button *ngIf="steamActiveGamerName" (click)="unlinkGamerName('STEAM')"
                class="admin-btn admin-btn--danger">
                Desvincular
              </button>
            </div>

            <ng-container *ngIf="steamActiveGamerName as steamTag; else noSteamTag">
              <div class="detail-kv">
                <span>Nome</span>
                <strong>{{ steamTag.gamer_name }}</strong>
              </div>
              <div class="detail-kv">
                <span>Vinculada em</span>
                <strong>{{
                  steamTag.created_at | date: "dd/MM/yyyy HH:mm"
                  }}</strong>
              </div>
            </ng-container>
            <ng-template #noSteamTag>
              <p class="detail-empty">
                Nenhuma gamertag ativa de Counter Strike.
              </p>
            </ng-template>
          </article>
        </div>

        <div class="detail-profile-grid detail-profile-grid--history">
          <article class="detail-card detail-card--nested">
            <h4>Historico LoL</h4>
            <ng-container *ngIf="previousRiotGamerNames.length > 0; else noRiotHistory">
              <ul class="detail-list">
                <li *ngFor="let nameInfo of previousRiotGamerNames">
                  <p>{{ nameInfo.gamer_name }}</p>
                  <span>{{ nameInfo.created_at | date: "dd/MM/yyyy" }}</span>
                </li>
              </ul>
            </ng-container>
            <ng-template #noRiotHistory>
              <p class="detail-empty">Nenhum historico anterior de LoL.</p>
            </ng-template>
          </article>

          <article class="detail-card detail-card--nested">
            <h4>Historico Counter Strike</h4>
            <ng-container *ngIf="previousSteamGamerNames.length > 0; else noSteamHistory">
              <ul class="detail-list">
                <li *ngFor="let nameInfo of previousSteamGamerNames">
                  <p>{{ nameInfo.gamer_name }}</p>
                  <span>{{ nameInfo.created_at | date: "dd/MM/yyyy" }}</span>
                </li>
              </ul>
            </ng-container>
            <ng-template #noSteamHistory>
              <p class="detail-empty">
                Nenhum historico anterior de Counter Strike.
              </p>
            </ng-template>
          </article>
        </div>
      </section>

      <section class="detail-section admin-surface">
        <div class="detail-section__header">
          <h3>Alertas da conta</h3>
          <div class="detail-header-actions">
            <button (click)="onDeactivateAllAlerts()" class="admin-btn admin-btn--danger">
              Desativar todos os alertas
            </button>
            <button (click)="openCreateAlertModal()" class="admin-btn admin-btn--primary"
              style="padding: 0.4rem 0.8rem; font-size: 0.8rem">
              + Novo Alerta
            </button>
          </div>

        </div>

        <div *ngIf="sortedAlerts.length > 0; else noAlerts" class="detail-table-wrapper detail-card--nested">
          <p-table [value]="user.alerts" [paginator]="true" [rows]="5" [totalRecords]="user.alerts.length">
            <ng-template pTemplate="header">
              <tr>
                <th>Data de Atualização</th>
                <th>Código</th>
                <th>Jogo</th>
                <th>Risco</th>
                <th>Ativo?</th>
                <th>Descrição do Caso</th>
                <th style="width: 120px">Ações</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-alert>
              <tr [class.kyc-active-row]="alert.is_active">
                <td>{{ alert.updated_at | date: "dd/MM/yyyy HH:mm" }}</td>
                <td>
                  <span class="status status--info">
                    {{ alert.alert_type?.code }}
                  </span>
                </td>
                <td>{{ alert.game }}</td>
                <td>
                  <span class="status" [ngClass]="alert.alert_type?.risk >= 7 ? 'status--danger' : 'status--warning'">
                    {{ alert.alert_type?.risk }}/10
                  </span>
                </td>
                <td>
                  <span [class.kyc-success-text]="alert.is_active">
                    {{ alert.is_active ? "Sim" : "Não" }}
                  </span>
                </td>
                <td>{{ alert.description }}</td>
                <td>
                  <button *ngIf="alert.is_active" pButton type="button" icon="pi pi-bell-slash" label="Desativar"
                    class="p-button-danger p-button-sm" [loading]="isLoadingAlert"
                    (click)="onDeactivateAlert(alert.id)">
                  </button>

                  <span *ngIf="!alert.is_active" class="text-muted" style="font-size: 0.85rem;">
                    Resolvido
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <ng-template #noAlerts>
          <p class="detail-empty">Nenhum alerta registrado para esta conta.</p>
        </ng-template>
      </section>

      <section class="detail-section admin-surface">
        <div class="detail-section__header">
          <h3>Notas da conta</h3>
          <button (click)="openNoteModal()" class="admin-btn admin-btn--primary"
            style="padding: 0.4rem 0.8rem; font-size: 0.8rem">
            + Nova Nota
          </button>
        </div>

        <ng-container *ngIf="sortedNotes.length > 0; else noNotes">
          <ul class="alert-timeline">
            <li *ngFor="let note of sortedNotes" class="alert-timeline__item">
              <span class="alert-severity alert-severity--info">NOTA</span>

              <div class="alert-timeline__content note-content-wrapper">
                <div class="note-text-area">
                  <p>{{ note.description }}</p>
                  <span>{{ note.created_at | date: "dd/MM/yyyy HH:mm" }}</span>
                </div>

                <div class="note-actions-inline">
                  <button class="note-icon-btn" (click)="openEditNoteModal(note)" title="Editar nota">
                    <i class="pi pi-pencil" aria-hidden="true"></i>
                  </button>
                  <button class="note-icon-btn note-icon-btn--danger" (click)="deleteNote(note.id)"
                    title="Deletar nota">
                    <i class="pi pi-trash" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </ng-container>
        <ng-template #noNotes>
          <p class="detail-empty">
            Nenhuma nota interna registrada para esta conta.
          </p>
        </ng-template>
      </section>

      <section class="detail-section admin-surface">
        <div class="detail-section__header">
          <h3>Verificação KYC</h3>
          <button *ngIf="hasActiveKYC" (click)="restartKYCProcess()" class="admin-btn admin-btn--danger">
            Reiniciar processo de KYC
          </button>
        </div>

        <div *ngIf="kycList && kycList.length > 0" class="detail-table-wrapper detail-card--nested">
          <p-table [value]="kycList" [paginator]="true" [rows]="5" [totalRecords]="kycList.length"
            [loading]="isLoadingKYC">
            <ng-template pTemplate="header">
              <tr>
                <th>Data de Criação</th>
                <th>Ativo?</th>
                <th>Status</th>
                <th>Link de Verificação</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-kyc>
              <tr [class.kyc-active-row]="kyc.is_active">
                <td>{{ kyc.created_at | date: "dd/MM/yyyy HH:mm" }}</td>
                <td>
                  <span [class.kyc-success-text]="kyc.is_active">
                    {{ kyc.is_active ? "Sim" : "Não" }}
                  </span>
                </td>
                <td>
                  <span class="status" [ngClass]="'status--' + kyc.status.toLowerCase()">
                    {{ kyc.status }}
                  </span>
                </td>
                <td>
                  <a [href]="
                      'https://station.veriff.com/verifications/' +
                      kyc.provider_session_id
                    " target="_blank" class="admin-link">
                    Abrir Link <i class="pi pi-external-link"></i>
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div *ngIf="!isLoadingKYC && (!kycList || kycList.length === 0)" class="detail-card detail-card--nested">
          <p class="detail-empty">
            Nenhuma verificação KYC encontrada para este usuário.
          </p>
        </div>
      </section>
    </div>
  </div>
</section>

<p-dialog [(visible)]="displayBalanceModal" [header]="user?.username || ''" [modal]="true" appendTo="body"
  position="center" [draggable]="false" [resizable]="false" [dismissableMask]="true" (onHide)="closeBalanceModal()"
  styleClass="balance-modal-dialog">
  <div class="balance-modal-content">
    <div class="balance-summary">
      <span class="balance-line"><strong>Saldo atual</strong></span>
      <span class="balance-line">Moedas: <strong>{{ userBalance?.coins || 0 }}</strong></span>
      <span class="balance-line">Diamantes: <strong>{{ userBalance?.diamonds || 0 }}</strong></span>
    </div>

    <div class="balance-filters">
      <label><input type="checkbox" [ngModel]="filterConversion"
          (change)="filterConversion = !filterConversion; onFilterChange()" />
        Conversão</label>
      <label><input type="checkbox" [ngModel]="filterBattlePrize"
          (change)="filterBattlePrize = !filterBattlePrize; onFilterChange()" />
        Premiação batalha</label>
      <label><input type="checkbox" [ngModel]="filterBattleCost"
          (change)="filterBattleCost = !filterBattleCost; onFilterChange()" />
        Custo batalha</label>
      <label><input type="checkbox" [ngModel]="filterBattlePassReward" (change)="
            filterBattlePassReward = !filterBattlePassReward; onFilterChange()
          " />
        Passe</label>
      <label><input type="checkbox" [ngModel]="filterHeroPurchase" (change)="
            filterHeroPurchase = !filterHeroPurchase; onFilterChange()
          " />
        Compra hero</label>
      <label><input type="checkbox" [ngModel]="filterCashOut"
          (change)="filterCashOut = !filterCashOut; onFilterChange()" />
        Saque</label>
      <label><input type="checkbox" [ngModel]="filterDeposits"
          (change)="filterDeposits = !filterDeposits; onFilterChange()" />
        Depósitos</label>
    </div>

    <div class="scroll-container" #scrollContainer>
      <div *ngIf="isLoadingTransactions">Carregando transações...</div>
      <div *ngIf="!isLoadingTransactions && paginatedTransactions.length === 0">
        Nenhuma transação encontrada
      </div>

      <table *ngIf="!isLoadingTransactions && paginatedTransactions.length > 0" class="balance-transactions-table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Valor</th>
            <th>Descrição</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let transaction of paginatedTransactions">
            <td>{{ transaction.created_at | date: "dd/MM/yyyy" }}</td>
            <td>
              {{ (transaction.amount ?? 0) > 0 ? "+" : ""
              }}{{ transaction.amount }} {{ transaction.currency }}
            </td>
            <td>{{ transaction.type_display || transaction.type }}</td>
            <td>{{ transaction.status_display || transaction.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-container">
      <button class="admin-btn admin-btn--secondary" (click)="previousPage()" [disabled]="currentPage === 1">
        Anterior
      </button>
      <span>Página {{ currentPage }} de {{ totalPages }}</span>
      <button class="admin-btn admin-btn--secondary" (click)="nextPage()" [disabled]="currentPage === totalPages">
        Próximo
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="displayNoteModal" [header]="editingNoteId ? 'Editar Nota' : 'Adicionar Nova Nota'" [modal]="true"
  appendTo="body" position="center" [draggable]="false" [resizable]="false" [dismissableMask]="true"
  (onHide)="closeNoteModal()" styleClass="note-modal-dialog">
  <div class="note-modal-content">
    <label for="noteDescription" class="note-label">Descrição da nota (Máx. 500 caracteres)</label>
    <textarea id="noteDescription" class="admin-input note-textarea" [(ngModel)]="newNoteText" rows="4" maxlength="500"
      placeholder="Ex: Usuário contatou o suporte..."></textarea>

    <div class="note-modal-actions">
      <button (click)="closeNoteModal()" class="admin-btn admin-btn--secondary" [disabled]="isSavingNote">
        Cancelar
      </button>
      <button (click)="saveNote()" class="admin-btn admin-btn--primary"
        [disabled]="!newNoteText.trim() || isSavingNote">
        {{
        isSavingNote
        ? "Salvando..."
        : editingNoteId
        ? "Atualizar Nota"
        : "Salvar Nota"
        }}
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Criar Novo Alerta" [(visible)]="displayCreateAlertModal" [modal]="true" appendTo="body"
  position="center" [draggable]="false" [resizable]="false" [dismissableMask]="true" [closable]="true"
  styleClass="alert-modal-dialog" [style]="{ width: '36rem', maxWidth: '95vw' }">
  <form class="create-user-form">
    <label>
      Código do Alerta *
      <p-dropdown [options]="alertTypeOptions" [(ngModel)]="newAlert.alert_code" (onChange)="onAlertTypeChange($event)"
        placeholder="Selecione um tipo cadastrado" name="alert_code" [appendTo]="'body'"
        panelStyleClass="alert-dropdown-panel" styleClass="admin-input">
      </p-dropdown>
    </label>

    <div style="display: flex; gap: 1rem;">
      <label style="flex: 0 0 120px;">
        Risco
        <input type="number" pInputText class="admin-input" [(ngModel)]="newAlert.alert_risk" [readonly]="true"
          name="alert_risk" placeholder="0" />
      </label>

      <label style="flex: 1;">
        Descrição Geral do Tipo
        <input type="text" pInputText class="admin-input" [(ngModel)]="newAlert.alert_description" [readonly]="true"
          name="alert_description" />
      </label>
    </div>

    <label>
      Jogo *
      <p-dropdown [options]="gameOptions" [(ngModel)]="newAlert.game" placeholder="Selecione o jogo" name="game"
        styleClass="admin-input">
      </p-dropdown>
    </label>

    <label>
      Descrição do Caso *
      <textarea pInputTextarea class="admin-input" name="description" rows="3" [(ngModel)]="newAlert.description"
        placeholder="Detalhes observados sobre o comportamento do usuário...">
      </textarea>
    </label>

  </form>

  <ng-template pTemplate="footer">
    <div class="create-user-form__actions"> <button type="button" class="admin-btn admin-btn--secondary"
        (click)="displayCreateAlertModal = false" [disabled]="isSubmittingAlert">
        Cancelar
      </button>
      <button type="button" class="admin-btn admin-btn--primary" (click)="onSubmitNewAlert()"
        [disabled]="!newAlert.alert_code || !newAlert.game || isSubmittingAlert">
        {{ isSubmittingAlert ? 'Salvando...' : 'Salvar Alerta' }}
      </button>
    </div>
  </ng-template>
</p-dialog>